/**
 * Created by munky on 1/3/17.
 */
// @flow
import React from "react";
import styled, { css } from "styled-components";
import { compose, withHandlers, onlyUpdateForKeys, lifecycle, withProps } from "recompose";
import lightCross from "../../../images/cross.png";
import darkCross from "../../../images/x.svg";

export const deviceHasTouch = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

export const noTouch = (...args) => (deviceHasTouch() ? "" : css(...args));

export const hover = (...args) => noTouch`
  &:hover {
    ${css(...args)}
  }
`;

type ModalProps = {
  children: any,
  open: boolean,
  onRequestClose: () => void,
  handleClose: () => void,
  className: string,
  showCloseButton: Boolean,
};

const Modal = function Modal(props: ModalProps) {
  const { children, open, className, showCloseButton = true } = props;

  return (
    <OuterModal open={open} onClick={props.handleClose} data-close>
      <InnerModal open={open} className={className} withoutRadius={props.withoutRadius}>
        {children}
        {showCloseButton && (
          <CloseButtonContainer>
            <CloseButton onClick={props.handleClose} data-close darkCloseButton={props.darkCloseButton} />
          </CloseButtonContainer>
        )}
      </InnerModal>
    </OuterModal>
  );
};

const isIphone = typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);

export default compose(
  withHandlers({
    handleClose: props => evt => {
      if (props.onRequestClose && evt.target.dataset.close) {
        props.onRequestClose();
      }
    },
  }),
  onlyUpdateForKeys(["open", "children", "className"]),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.open && isIphone) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.height = "100%";
      } else {
        document.body.style = {};
      }
    },
  })
)(Modal);

export const rotateOnHover = (grads = 360) => hover`
  transform: rotateZ(${grads}deg) scale(1.3);
`;

const CloseButtonContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: 35px;
  right: 35px;
  width: 50px;
  height: 50px;
  @media (max-width: 640px) {
    right: 23px;
  }
`;
const CloseButton = withProps(({ darkCloseButton }) => ({
  src: darkCloseButton ? darkCross : lightCross,
}))(styled.img`
  position: absolute;
  top: calc(50% -12px);
  right: 0px;
  width: 24px;
  height: 24px;
  transition: 0.3s;
  ${rotateOnHover(90)};
`);

const OuterModal = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  ${({ open }) => `
    z-index: ${open ? 99999999999 : -1};  
    visibility: ${open ? "visible" : "hidden"};
    opacity: ${open ? 1 : 0};
    `};
`;

// overflow-y: auto;
const InnerModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  max-height: 100%;
  border-radius: ${({ withoutRadius }) => (withoutRadius ? "0px" : "10px")};
  box-shadow: 0px 2px 34px 0px rgba(0, 0, 0, 0.24);
  transition: 0.5s;
  @media (max-width: 640px) {
    max-height: 90%;
    max-width: 90%;
  }
  ${({ open }) => `
    transform: translate3d(-50%,${open ? -50 : -40}%,0);
    ${
      !open
        ? `
    pointer-events:none;
    `
        : ""
    }
  `};
`;

export const ModalTitle = styled.div`
  color: black;
  margin: 15px 0px 30px;
  text-align: center;
  font-weight: 600;
  line-height: 28px;
  font-size: 22px;
  font-family: "Montserrat";
  letter-spacing: -0.24;
`;

export const ModalSubtitle = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  font-weight: normal;
  margin-right: 10px;
  font-family: "Montserrat";
  margin-top: 8px;
`;
